<template>
  <div class="wrap reserve-wrap">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="top-header">
      <incBack></incBack>
      <h3>예약하기</h3>
    </div>
    <div class="body-wrap">
      <!-- <h5>예약 가능 회기 <span class="bold">5</span></h5> -->

      <VueSlickCarousel @afterChange="onAfterChange" :swipe="false" :arrows="false" :dots="false" ref="carousel" :infinite="false">
        <!-- 코칭 날짜 선택 -->
        <div>
          <p class="count">
            예약 가능 회기 <span>{{ leffSession - tempDate.length }}</span>
          </p>
          <h4 class="mt-10">
            희망 날짜와 시간을<br />
            선택해 주세요!
          </h4>
          <div class="pl-05 pr-05">
            <!-- <DatePicker :attributes="attributes" is-expanded style="border:none" locale="en" color="green" @dayclick="onDayClick"></DatePicker> -->
            <Calendar :attributes="attributes" @dayclick="onDayClick" is-expanded style="border: none" locale="en" color="green" :min-date="new Date()" />
          </div>

          <div class="time-wrap" v-for="(item, index) in this.tempDate" :key="index">
            <h2 class="clear">
              <img class="float-left mt-05" src="@/assets/img/time-icon.svg" alt="" />

              <!-- <img src="@/assets/img/time-icon.svg" alt=""> -->
              <span class="float-left">{{ item.id }} Time</span>
            </h2>
            <select name="time" id="" v-model="item.startTime" @change="changeTime(item.startTime, item.endTime)">
              <option :value="item.value" v-for="(item, index) in timeTable" :key="index">
                {{ item.text }}
              </option>
            </select>
            <span>~</span>
            <select name="time" id="" v-model="item.endTime" @change="changeTime(item.startTime, item.endTime)">
              <option :value="item.value" v-for="(item, index) in timeTable" :key="index">
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <h4>코치님과 어떻게<br />코칭을 받고 싶나요?</h4>
          <span class="survey-info">복수 선택 가능합니다.</span>
          <ul class="subject-wrap mt-30">
            <div class="question">
              <ul class="reserve-list">
                <li v-for="(item, index) in coachType" :key="index" @click="coachingTypeSelect(item)" :class="{ active: item.isActive }">
                  {{ item.text }}
                </li>
              </ul>
            </div>
          </ul>
        </div>

        <div>
          <h4>대면 코칭은<br />어디서 받고 싶나요?</h4>
          <div class="w-100per float-left mt-30">
            <ul>
              <li>
                <select name="" id="" v-model="tempSi">
                  <option value="">시 전체</option>
                  <option v-for="(item, index) in sido.sido" :key="index" :value="index">
                    {{ item }}
                  </option>
                </select>
              </li>
            </ul>
          </div>
          <div class="w-100per float-left mt-15">
            <ul>
              <li>
                <select name="" id="" v-model="tempGu">
                  <option value="">구/동 전체</option>
                  <option :value="index" v-for="(item, index) in sido.gun[tempSi]" :key="index">
                    {{ item }}
                  </option>
                </select>
              </li>
            </ul>
          </div>
        </div>

        <!-- 달성목표 -->
        <div>
          <h4>
            이번 코칭에서 달성하고 싶은<br />
            목표를 작성해주세요.
          </h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea
              name=""
              id="courseCoachingSubject"
              placeholder="Ex. 팀원들에게 좋은 피드백을 줄 수 있는 리더가 되기 위해 연구한다. "
              @keyup="keyupEvent"
              v-model="input.courseCoarchingSubject"
            ></textarea>
          </div>
        </div>

        <!-- 바라는점 -->
        <div>
          <h4>코치님에게 바라는 점이나 기타 의견을 작성해 주세요.</h4>
          <!-- 코칭 목표 작성 -->
          <div class="goal-wrap pl-05 pr-05">
            <!-- 작성할 때 class="active" -->
            <textarea name="" id="courseCoarchingEtc" v-model="input.courseCoarchingEtc"></textarea>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
    <div class="bnb-btn" :class="{ 'bnb-btn-static': currentSlide == 2 || currentSlide == 1 }">
      <!-- 선택 시 class="active" 활성화 -->
      <p class="mb-10" v-if="currentSlide == 1">코치님과 상의 후 가능 지역은 변경 될 수 있습니다.</p>
      <button @click="next()" :class="{ active: isActive }">NEXT</button>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Calendar from "v-calendar/lib/components/calendar.umd";
import VueSlickCarousel from "vue-slick-carousel";
import { sidogun } from "@/utils/sido.js";
import dayjs from "dayjs";
import Loading from "@/components/inc/inc_loading.vue";
// import dayjs from 'dayjs';
export default {
  name: "reserve",
  props: {
    idx: {
      type: [Number, String],
      default: 0,
    },
    rebook: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    currentSlide: 0,
    date: new Date(),
    coachType: [
      {
        idx: 1,
        text: "화상 코칭",
        value: "화상",
        isActive: false,
      },
      {
        idx: 2,
        text: "대면 코칭(오프라인)",
        value: "대면",
        isActive: false,
      },
      {
        idx: 3,
        text: "전화 코칭",
        value: "전화",
        isActive: false,
      },
    ],
    timeTable: [],
    input: {
      courseType: [],
      courseCity: "",
      courseGu: "",
      idxTbUser: 0,
      idxTbCoarch: 0,
      courseCoarchingSubject: "",
      courseCoarchingEtc: "",
      courseIdx: "",
    },
    tempDate: [],
    tempType: [],
    start_tiem: "",
    end_tiem: "",
    isActive: false,
    session_count: 5,
    tempSi: "",
    tempGu: "",
    sido: {},
    leffSession: 0,
    isLoadingPop: false,
  }),
  computed: {
    dates() {
      return this.tempDate.map((day) => day.date);
    },
    attributes() {
      return this.dates.map((date) => ({
        highlight: true,
        dates: date,
      }));
    },
  },
  components: {
    VueSlickCarousel,
    //   DatePicker,
    Calendar,
    incBack,
    Loading,
  },
  mounted() {
    this.input.idxTbUser = this.$store.state.courseInfo.userIdx;
    this.input.idxTbCoarch = this.idx;
    this.sido = sidogun();
    this.timeTable = [];
    for (let i = 0; i < 24; i++) {
      let time = i < 10 ? "0" + i + ":00" : i + ":00"; // 00 : 00
      let time2 = i < 10 ? "0" + i + ":30" : i + ":30"; // 00 : 30
      this.timeTable.push({ value: time, text: time });
      this.timeTable.push({ value: time2, text: time2 });
    }
    setTimeout(() => {
      this.inputSubjectSetting();
    }, 1000);
    this.getLeffSessionCount();
  },
  methods: {
    inputSubjectSetting() {
      let subject = document.getElementById("courseCoachingSubject");
      // console.log(subject);
      subject.addEventListener("input", (event) => {
        this.input.courseCoarchingSubject = event.target.value;
      });
      let etc = document.getElementById("courseCoarchingEtc");
      etc.addEventListener("input", (event) => {
        this.input.courseCoarchingEtc = event.target.value;
      });
    },

    changeTime(startTime, endTime) {
      if (startTime != "" && endTime != "") {
        let curDate = dayjs().format("YYYY-MM-DD");
        let sTime = new Date(curDate + " " + startTime);
        let eTime = new Date(curDate + " " + endTime);
        if (sTime.getTime() >= eTime.getTime()) {
          alert("시간 지정이 올바르지 않습니다.");
          return false;
        }
      }
    },
    getLeffSessionCount() {
      let parmas = {
        idxTbUser: 0,
        courseIdx: 0,
      };
      parmas.idxTbUser = this.$store.state.userInfo.userIdx;
      parmas.courseIdx = this.$store.state.courseInfo.courseIdx;
      this.axios
        .get(`/admin/leftsessionsearch?courseIdx=${parmas.courseIdx}&idxTbUser=${parmas.idxTbUser}`)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.leffSession = res.data.data[0].leftSession;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    keyupEvent() {
      if (this.input.courseCoarchingSubject != "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    onAfterChange(slideIndex) {
      this.currentSlide = slideIndex;
      if (this.currentSlide == 2 || this.currentSlide == 3) {
        this.isActive = false;
      }
    },
    onDayClick(day) {
      let today = dayjs();
      let expired_at = dayjs(day.id);
      let result = expired_at.diff(today, "day", true);
      let dDay = Math.floor(result);
      if (dDay <= -2) {
        alert("선택이 불가능한 날짜입니다.");
        return false;
      }

      if (this.tempDate.length > 0) {
        this.tempDate[0]["id"] = day.id;
        this.tempDate[0]["date"] = day.date;
        this.tempDate[0]["startTime"] = "";
        this.tempDate[0]["endTime"] = "";
      } else {
        this.tempDate.push({
          id: day.id,
          date: day.date,
          startTime: "",
          endTime: "",
        });
      }

      this.tempDate = this.tempDate.sort((a, b) => {
        return a.date.getTime() - b.date.getTime();
      });

      if (this.tempDate < 1) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    coachingTypeSelect(item) {
      // item.isActive =
      if (!item.isActive) {
        item.isActive = true;
        this.tempType.push(item);
      } else {
        let idx = this.tempType.findIndex((itm) => {
          return itm.idx == item.idx;
        });
        this.tempType.splice(idx, 1);
        item.isActive = false;
      }

      if (this.tempType.length < 1) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    splitDate(str) {
      const split = str.split("-");
      return split;
    },
    splitTime(str) {
      const split = str.split(":");
      return split;
    },
    next() {
      window.scrollTo(0, 0);
      if (this.isActive) {
        if (this.currentSlide == 0) {
          if (this.tempSi == "") {
            this.input.courseCity = "";
            this.input.courseGu = "";
          } else {
            this.input.courseCity = this.sido.sido[this.tempSi];
            this.input.courseGu = this.sido.gun[this.tempSi][this.tempGu];
          }

          if (this.tempDate.length == 0) {
            alert("예약하실 날짜를 선택해주세요.");
            return false;
          }

          for (let item of this.tempDate) {
            if (item.startTime == item.endTime) {
              alert("동일한 시간대는 선택할수 없습니다.");
              return false;
            }

            //let startTime = new Date(item.id + " " + item.startTime);
            //let endTime = new Date(item.id + " " + item.endTime);
            let toTime = new Date();
            const startDateReturn = this.splitDate(item.id);
            const startTimeReturn = this.splitTime(item.startTime);

            const endDateReturn = this.splitDate(item.id);
            const endTimeReturn = this.splitTime(item.endTime);

            let startTime = new Date(startDateReturn[0], startDateReturn[1] - 1, startDateReturn[2], startTimeReturn[0], startTimeReturn[1]);
            let endTime = new Date(endDateReturn[0], endDateReturn[1] - 1, endDateReturn[2], endTimeReturn[0], endTimeReturn[1]);

            if (startTime.getTime() <= toTime.getTime()) {
              alert("현재시간보다 이전 시간은 선택할수없습니다.");
              return false;
            }
            if (startTime.getTime() >= endTime.getTime()) {
              alert("시간 지정이 올바르지 않습니다.");
              return false;
            }
          }
          let days = this.tempDate
            .map((elem) => {
              return elem.id + " " + elem.startTime + "~" + elem.endTime;
            })
            .join(" / ");
          if (confirm(days + "\n예약하시겠습니까?")) {
            this.$refs.carousel.next();
          }
        } else if (this.currentSlide === 1) {
          let is_offline = false;
          for (let i = 0; i < this.tempType.length; i++) {
            if (this.tempType[i].value == "대면") {
              is_offline = true;
              break;
            }
          }
          if (is_offline) {
            this.$refs.carousel.next();
          } else {
            this.$refs.carousel.goTo(3);
          }
        } else if (this.currentSlide == 4) {
          this.isLoadingPop = true;
          this.input.idxTbUser = this.$store.state.userInfo.userIdx;
          this.input.idxTbCoarch = this.idx;
          this.input.courseIdx = this.$store.state.courseInfo.courseIdx;

          if (this.tempSi == "") {
            this.input.courseCity = "";
            this.input.courseGu = "";
          } else {
            this.input.courseCity = this.sido.sido[this.tempSi];
            this.input.courseGu = this.sido.gun[this.tempSi][this.tempGu];
          }
          this.input.courseType = [];
          for (let item of this.tempType) {
            this.input.courseType.push(item.value);
          }

          let form = new FormData();
          for (const [key, value] of Object.entries(this.input)) {
            form.append(key, value);
          }

          for (let item of this.tempDate) {
            form.append("courseTime1", item.id + " " + item.startTime);
            form.append("courseTime2", item.id + " " + item.endTime);
          }

          if (this.rebook == 1) {
            //재예약
            form.append("coarchingIdx", this.$store.state.currentCoarching);
            this.axios
              .post("/front/user/recommendCoarch/apply/add", form)
              .then((res) => {
                if (res.data.success) {
                  this.isLoadingPop = false;
                  this.$router.push("/reserve_finish");
                } else {
                  this.isLoadingPop = false;
                  alert("더 이상 추가 할 수 없습니다.");
                }
              })
              .catch((err) => {
                this.isLoadingPop = false;
                alert("네트워크 연결 상태가 좋지 않습니다.");
                console.log("recomentCoarh-apply err : ", err);
              });
          } else {
            //첫예약
            this.axios
              .post("/front/user/recommendCoarch/apply", form)
              .then((res) => {
                if (res.data.success) {
                  this.isLoadingPop = false;
                  this.$router.push("/reserve_finish");
                } else {
                  if (res.data.message.includes("DROP")) {
                    alert("DROP된 과정입니다.");
                    this.isLoadingPop = false;
                    return false;
                  } else {
                    this.isLoadingPop = false;
                    alert(res.data.message);
                    return false;
                  }
                  //
                  // console.log(res.data);
                }
              })
              .catch((err) => {
                this.isLoadingPop = false;
                alert("네트워크 연결 상태가 좋지 않습니다.");
                console.log("recomentCoarh-apply err : ", err);
              });
          }
        } else if (this.currentSlide == 3) {
          this.$refs.carousel.next();
        } else {
          this.$refs.carousel.next();
        }
      }
    },
  },
  //watch
  watch: {
    tempSi(curVal) {
      //시 선택시 구 값 확인 후 isActive 활성화
      if (curVal !== "" && this.tempGu !== "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    tempGu(curVal) {
      //시 선택시 구 값 확인 후 isActive 활성화
      if (curVal !== "" && this.tempSi !== "") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
};
</script>
<style scoped>
.bnb-btn-static {
  position: static;
  margin-top: 10px;
  padding-bottom: 40px;
}
</style>
